export default "__VITE_ASSET__2e1SC5vf__"